import { makeStyles } from 'tss-react/mui'

const resetBtn = {
  appearance: 'none' as const,
  WebkitAppearance: 'none' as const,
  border: 'none',
  background: 'transparent',
  boxShadow: 'none',
  outline: 'none',
  margin: 0,
  fontFamily: 'inherit',
  cursor: 'pointer',
}

/**
 * Prompt cards match the AI skills sample prompts (Figma 641:2616).
 * The heading matches the chat panel greeting.
 */
export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 24,
    width: '100%',
    maxWidth: 552,
    padding: '0 8px',
    boxSizing: 'border-box',
  },
  greeting: {
    margin: 0,
    width: '100%',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 400,
    fontSize: 22,
    lineHeight: '28px',
    textAlign: 'center',
    color: theme.palette.labraText.description,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 24,
    width: '100%',
  },
  card: {
    ...resetBtn,
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    textAlign: 'left',
    padding: '4px 8px',
    backgroundColor: 'rgba(255, 255, 255, 0.58)',
    borderLeft: '2px solid #b56abb',
    borderRadius: '0 6px 6px 0',
    minWidth: 0,
    '&:hover, &:focus-visible': {
      backgroundColor: '#f6f7f9',
    },
  },
  cardHover: {
    backgroundColor: '#f6f7f9',
  },
  text: {
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '17px',
    color: '#2e3132',
    '& .muted': { color: '#6a777a' },
    '& em': {
      fontStyle: 'italic',
      fontWeight: 500,
      color: '#2e3132',
    },
  },
  tooltip: {
    position: 'absolute',
    left: 0,
    bottom: 'calc(100% + 8px)',
    zIndex: 2,
    backgroundColor: '#2e3132',
    color: '#dbe4e6',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '16px',
    padding: '4px 8px',
    borderRadius: 4,
    whiteSpace: 'normal',
    maxWidth: 260,
    pointerEvents: 'none',
  },
}))
